import React from "react";

const HotelBooking = () => {
  return <div>HotelBooking</div>;
};

export default HotelBooking;
